//Page Components
import Prices1 from "../components/PricesFirstPage";
import Prices2 from "../components/PricesSecondPage";

const Prices = () => {
  return (
    <div>
      <Prices1 />
      <Prices2 />
    </div>
  );
};

export default Prices;
